<div class="c-icon"
  [ngClass]="[
    'c-icon--size-' + size
  ]">
  <mat-icon
    [svgIcon]="set + ':' + name"
    [inline]="true">
  </mat-icon>
</div>
